<template>
  <div>
    <v-row class="mb-5">
      <v-col cols="12" sm="6" md="4">
        <v-card>
          <v-card-text @click="filtrar('')" class="filtros d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ qtdAgentes + qtdGestores }}
              </h2>
              <span>Total</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg second--text`">
              <v-icon size="25" class="rounded-0" color="primary">
                {{ icons.mdiAccountMultipleOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-card>
          <v-card-text @click="filtrar('Agente')" class="filtros d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ qtdAgentes }}
              </h2>
              <span>Agente</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg primary--text`">
              <v-icon size="25" class="rounded-0" color="primary">
                {{ icons.mdiAccountMultiplePlusOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-card>
          <v-card-text @click="filtrar('Gestor')" class="filtros d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ qtdGestores }}
              </h2>
              <span>Gestor</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg accent--text`">
              <v-icon size="25" class="rounded-0" color="primary">
                {{ icons.mdiAccountStarOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiAccountStarOutline, mdiAccountMultipleOutline, mdiAccountMultiplePlusOutline, mdiAccountMultipleMinusOutline } from '@mdi/js'

export default {
  props: {
    qtdGestores: {
      type: Number,
      required: true,
    },
    qtdAgentes: {
      type: Number,
      required: true,
    },
  },

  methods: {
    filtrar(item) {
      this.$emit('alterarFiltro', item)
    },
  },

  setup() {
    return {
      icons: {
        mdiAccountMultiplePlusOutline,
        mdiAccountStarOutline,
        mdiAccountMultipleOutline,
        mdiAccountMultipleMinusOutline,
      },
    }
  },
}
</script>

<style>
.filtros {
  cursor: pointer;
}
.filtros:hover {
  background-color: rgba(196, 142, 255, 0.2);
}
</style>
